import { render, staticRenderFns } from "./NotificationTerminateModal.vue?vue&type=template&id=0065387d&scoped=true&lang=pug"
import script from "./NotificationTerminateModal.vue?vue&type=script&lang=ts"
export * from "./NotificationTerminateModal.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTerminateModal.vue?vue&type=style&index=0&id=0065387d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065387d",
  null
  
)

export default component.exports